/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcErrorCircleRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M12 2.9a9.1 9.1 0 1 0 0 18.2 9.1 9.1 0 0 0 0-18.2M1.1 12C1.1 5.98 5.98 1.1 12 1.1S22.9 5.98 22.9 12 18.02 22.9 12 22.9 1.1 18.02 1.1 12"
        clipRule="evenodd"
      />
      <path d="M10.824 7.748a1.178 1.178 0 1 1 2.351 0l-.293 4.92a.885.885 0 0 1-1.765 0zM10.5 16.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" />
    </svg>
  );
}
export default IcErrorCircleRegular;
